/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Office/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import City from './City/index'
import Name from './Name/index'
import React from 'react'
import State from './State/index'
import Street from './Street/index'
import Zip from './Zip/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Office({
  children,
  viewPath = "/DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem/Edit/Content/Details/Office"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Office.Vertical"
  data-view-path={viewPath}
 style={{'--pl-1-Z2hO0oT': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Office.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<Street
  viewPath={`${viewPath}/Street`}
/>
<City
  viewPath={`${viewPath}/City`}
/>
<State
  viewPath={`${viewPath}/State`}
/>
<Zip
  viewPath={`${viewPath}/Zip`}
/>
</div>
</div>
{children}
</React.Fragment>)
}